<template lang="pug">
  .WhyCanWeDoIt
    h1(:class="titleAnimation") 为什么我们能做到？
    h2(:class="titleAnimation") Why can we do it
    .flex-box(:class="slide")
      .prevBtn(v-show="isScroll || !isPhone" @click="prev")
      .partners(ref="partners")
        .partner(v-for="(item, index) in partners", :class="[contentAnimation, `animateDelay-${index}`]")
          img(:src="item.img")
          .name {{ item.name }}
          .title {{ item.title }}
          p.text {{ item.text }}
      .nextBtn(v-show="isScroll || !isPhone" @click="next")
</template>

<script>
  import Mixin from '../index.js'
  import {isPhone} from "@/utils/utils";

  import {photos} from '@/utils/images';
  const {Ido, Poisson, Ender, Alex, JJLin, Woodie, Zhong} = photos;
  
  export default {
    name: "WhyCanWeDoIt",
    mixins: [Mixin],
    data() {
      return {
        partners: [
          // {img: Ido, name: "Ido", title: 'CEO&联合创始人', text: '原电通大数据CEO\n腾讯投资战略总监\n南方都市报运营总经理'},
          {img: Poisson, name: "Poisson", title: 'CEO', text: '原腾讯T4大数据和AI应用专家，15年大数据经验,\n曾服务过腾讯、阿里、华为等多家公司'},
          {img: Ender, name: "Ender", title: 'VP产品/运营', text: '原大疆高级产品经理，\n15年工作经验，\n曾任职腾讯、大疆，并成功创业两轮并融资'},
          {img: Alex, name: "Alex", title: '首席架构师', text: '原百度地图LBS/无线资深架构师，腾讯地图/智慧出行/导航资深架构师\n15年以上软件架构设计经验'},
          {img: JJLin, name: "JJLin", title: '首席科学家', text: '中科院AI博士\n发表多篇国际顶级图像和NLP论文'},
          {img: Woodie, name: "Woodie", title: '大数据专家', text: '7年大数据经验\n原腾讯T3高级工程师\n曾主导腾讯PCG数据仓库/数据集市/用户画像项目的构建'},
          {img: Zhong, name: "Zhong", title: '中台技术专家', text: '10余年的数据应用经验\n原阿里巴巴LBS大数据中台技术负责人，技术专家。'},
        ],
      };
    },
    watch: {},
    computed: {
      isScroll() {
        return true;
      },
      isPhone,
      slide() {
        if (this.isPhone) {
          return 'slide';
        }
      },
    },
    methods: {
      prev() {
        const partners = this.$refs['partners'];
        const target = Math.max(partners.scrollLeft - 200, 0);
        const prev = () => {
          if (partners.scrollLeft >= target + 1) {
            partners.scrollTo(Math.max(partners.scrollLeft - 10, target), 0)
          } else {
            return
          }
          window.requestAnimationFrame(prev);
        }
        prev();
      },
      next() {
        const partners = this.$refs['partners'];
        const target = Math.min(partners.scrollLeft + 200, partners.scrollWidth - partners.offsetWidth);
        const next = () => {
          if (partners.scrollLeft <= target - 1) {
            partners.scrollTo(Math.min(partners.scrollLeft + 10, target), 0)
          } else {
            return
          }
          window.requestAnimationFrame(next)
        };
        next();
      },
    },
  };
</script>

<style scoped lang="stylus">
  @import "../index.styl"
  .WhyCanWeDoIt {
    VStack(center)
    padding 100px 0
    background-color #f8f8f8
    border-top 1px solid #e4e4e4
    border-bottom 1px solid #e4e4e4
    .flex-box {
      HStack(flex-start, center)
      width calc(100% - 0px)
    }
    .prevBtn, .nextBtn {
      flex-shrink 0
      width 44px
      height 44px
      margin 100px
      border-radius 50%
      border 1px solid #eeeeee
      background-color white
      cursor pointer
    }
    .prevBtn {
      background url("../../../assets/images/arrow-left-1.png") no-repeat center
    }
    .nextBtn {
      background url("../../../assets/images/arrow-right-1.png") no-repeat center
    }
    .partners {
      HStack(flex-start)
      margin-top 22px
      max-width 1180px
      overflow hidden
      .partner {
        width 175px
        flex-shrink 0
        margin 0 15px
        &:first-child {
          margin-left 0
        }
        &:last-child {
          margin-right 0
        }
        .name {
          color #202020
          FontSetting(Montserrat)
          font-size 28px
          font-weight 400
          margin-top 10px
        }
        .title {
          FontSetting("思源黑体")
          font-weight 400
          font-size 18px
          color #555
          margin 10px 0 16px
        }
        .text {
          FontSetting("思源黑体")
          font-weight 300
          font-size 14px
          line-height 24px
          color #999
        }
      }
    }
    .slide {
      .prevBtn, .nextBtn {
        display none
      }
      .partners {
        overflow auto
        width 90%
      }
    }
    @media (max-width screenWidth) {
      padding 50px 0
      width 100vw
      .prevBtn, .nextBtn {
        display none
      }
      .partners {
        width 100%
        HStack()
        flex-wrap wrap
        .partner {
          margin 0
          width 50%
          padding 14px
          box-sizing border-box
          &:first-child {
            margin 0
          }
          &:laste-child {
            margin 0
          }
          img {
            width 100%
          }
          .name {
            font-size 22px
          }
          .title {
            font-size 16px
          }
        }
      }
    }
  }
</style>
